<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true" :model="params">
        <el-form-item :label="$t('attendanceRecord.dataRange')">
          <el-date-picker
            class="pickData_cla"
            v-model="value2"
            type="datetimerange"
            @clear="searchFn"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="type" :label="$t('datapush.dataType')">
          <zk-dictionary-select
            :placeholder="$t('developer.selectDataType')"
            type="pushEvent"
            v-model="params.sid"
            style
          ></zk-dictionary-select>
          <el-button @click="searchFn" icon="el-icon-search">
            {{ this.$t('common.search') }}
          </el-button>
        </el-form-item>
      </el-form>
      <zk-button-group
        @pushDataEvent="appPushEvent()"
        @pushSelectData="pushSelectData()"
        groupName="pushData-button"
      ></zk-button-group>
    </div>

    <el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <!--<el-table-column prop="pushURL"
                         :label="this.$t('datapush.pushURL')">
          <template> N/A </template>
        </el-table-column>-->
        <el-table-column
          prop="sid"
          :label="this.$t('datapush.dataType')"
        ></el-table-column>
        <!-- <el-table-column prop="mid" width="100" :label="this.$t('datapush.mid')"></el-table-column> -->
        <el-table-column prop="num" :label="this.$t('datapush.num')">
          <template slot-scope="scope">
            <div class="num_cla" @click.stop="showMessage(scope.row)">
              {{ scope.row.num }}
              <i class="el-icon-question"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="message" :label="this.$t('datapush.message')">
          <template slot-scope="scope">
            <el-popover width="350" trigger="hover" placement="top">
              <p>{{ scope.row.message }}</p>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.message }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedDate"
          :label="this.$t('datapush.lastPushTime')"
        >
          <template slot-scope="scope">
            {{ scope.row.updatedDate | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="dataPeriod"
          :label="this.$t('datapush.dataPeriod')"
        >
          <template>N/A</template>
        </el-table-column>
        <el-table-column
          prop="lastPushStatus"
          :label="this.$t('datapush.lastPushStatus')"
        >
          <template>failure</template>
        </el-table-column>
        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <zk-button-group
              :event="['pushSingleDataEvent']"
              @pushSingleDataEvent="appPushEventRow(scope.row)"
              groupName="pushSingleData-button"
            ></zk-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div pagination-margin-top>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total"
      ></el-pagination>
    </div>

    <el-dialog
      :title="this.$t('pushStation.errorRecord')"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose"
    >
      <el-scrollbar style="max-height:300px;overflow-Y:auto">
        <el-timeline :reverse="true">
          <el-timeline-item
            v-for="item in errorMsg"
            :key="item.id"
            :timestamp="item.createdDate | dataFormat"
            style="padding:10px;"
            placement="top"
            color="#F56C6C"
            >{{ item.responseMessage }}</el-timeline-item
          >
        </el-timeline>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { findByPage, rePushIds, rePushAll } from '@/services/datapushApi.js'
import { Loading } from 'element-ui'
import pickerOptions from '@/utils/pickerOptions.js'
import { getErrorMsg } from '@/services/appManagerApi.js'
import { getCurrentDateStartAndEndTime } from '@/utils/utils.js'
export default {
  data() {
    return {
      pickerOptions: pickerOptions(this),
      value2: [],
      records: null,
      params: {
        appKey: '',
        sid: ''
      },
      Interval: null,
      tableData: [],
      multipleSelection: null,
      eventType: [],
      errorMsg: [],
      dialogVisible: false
    }
  },

  props: {
    appInfo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  watch: {
    'appInfo.appKey': {
      handler: function(val, oVal) {
        if (val) {
          this.searchFn()
          this.InterFun()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.value2 = getCurrentDateStartAndEndTime()
    if (this.appInfo.appKey) {
      this.searchFn()
      this.InterFun()
    }
  },
  destroyed() {
    if (this.Interval) {
      clearInterval(this.Interval)
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    showMessage(row) {
      let params = {
        mid: row.mid
      }
      getErrorMsg(params)
        .then(data => {
          if (data.code === '00000000') {
            this.errorMsg = data.payload.results.pushRecords
            this.loadDataList(true)
          } else {
            this.$message.error(data.message)
          }
          this.dialogVisible = true
        })
        .catch(e => {})
    },
    appPushEvent() {
      // 推送所有数据
      let params = {
        appKey: this.appInfo.appKey
      }
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('datapush.pushLoad'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      rePushAll(params)
        .then(data => {
          if (data.code === '00000000') {
            this.closeLoad()
            setTimeout(() => {
              this.$message({
                message: this.$t('datapush.asyPushTip'),
                type: 'success',
                duration: 4000
              })
            }, 500)
          } else {
            this.closeLoad(1)
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => {
          this.closeLoad()
        })
    },
    InterFun() {
      if (this.Interval) {
        clearInterval(this.Interval)
        this.Interval = null
      }
      this.Interval = setInterval(() => {
        if (this.pager.total > 0) {
          this.loadDataList(true)
        }
      }, 10000)
    },
    pushSelectData() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.errorMessage(this.$t('common.selectRecod'))
        return false
      } else {
        let ids = this.multipleSelection.map(item => {
          return item.id
        })
        this.pushDataFun(ids)
      }
    },
    closeLoad(time) {
      if (this.loadingInstance) {
        setTimeout(() => {
          this.loadingInstance.close()
        }, time || 500)
      }
    },
    appPushEventRow(row) {
      this.pushDataFun([row.id])
    },
    pushDataFun(ids) {
      let params = {
        ids: ids
      }
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('datapush.pushLoad'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      rePushIds(params)
        .then(data => {
          if (data.code === '00000000') {
            this.closeLoad()
            let result = data.payload.results
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                message: `<div><strong>${this.$t('datapush.total')}：</strong>${
                  result.total
                }</div>
                 <div style='color:#67c23a'><strong>${this.$t(
    'datapush.success'
  )}：</strong>${result.success}</div>
                 <div style='color:#ea1422'><strong>${this.$t(
    'datapush.fail'
  )}：</strong>${result.fail}</div>`,
                duration: 5000
              })
            }, 500)
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => {
          this.closeLoad()
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(pageSize) {
      this.pager.pageSize = pageSize
      this.loadDataList()
    },
    handleCurrentChange(current) {
      this.pager.curPage = current
      this.loadDataList()
    },
    searchFn() {
      this.pager.curPage = 1
      this.loadDataList()
    },
    loadDataList(hideLoading) {
      if (this.value2 && this.value2.length > 0) {
        this.params.beginTime = this.value2[0].getTime() // getStartTime()
        this.params.endTime = this.value2[1].getTime() // getEndTime()
      } else {
        this.params.beginTime = ''
        this.params.endTime = ''
      }
      if (!(this.appInfo && this.appInfo.appKey)) {
        return false
      }
      this.params.appKey = this.appInfo.appKey
      let params = {
        params: this.params,
        pager: this.pager
      }
      if (!hideLoading) {
        this.loadingInstance = Loading.service({
          lock: true,
          fullscreen: true,
          text: this.$t('common.loginLoading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      findByPage(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
            if (data.payload.curPage > data.payload.totalPages) {
              this.pager.curPage =
                data.payload.totalPages === 0 ? 1 : data.payload.totalPages
            } else {
              this.pager.curPage = data.payload.curPage
            }
            this.pager.pageSize = data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => {
          this.closeLoad(100)
        })
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
.search-bar-margin-bottom-cla {
  display: flex;
  justify-content: flex-start;
  padding-left: 0px;
  /deep/.zk_btn_group_cla {
    padding: 0px;
  }
}
.el-form-item {
  float: left;
}

.push_cla {
  padding: 0px;
  margin-top: 1px;
  margin-left: 5px;
  .el-button {
    padding: 11px 7px !important;
  }
}
.name-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.question_cla {
  position: relative;
  margin-left: 10px;
  top: 10px;
  height: 20px;
  width: 20px;
}
.num_cla {
  color: @themeColor;
  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/pushDataList.vue